export default {
  objective: 'OBJECTIVE',
  video_title: 'SEEING IS BELIEVING',
  video: 'INSTRUCTION VIDEO',
  attention: 'ATTENTION PLEASE'
}
